import { render, staticRenderFns } from "./PageItem.vue?vue&type=template&id=6bc69121"
import script from "./PageItem.vue?vue&type=script&lang=js"
export * from "./PageItem.vue?vue&type=script&lang=js"
import style0 from "./PageItem.vue?vue&type=style&index=0&id=6bc69121&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports